import { Box, Button, Grid, TextField, Typography } from '@mui/material';
import { useEffect, useRef, useState } from 'react';
import { IPostModel } from '../../../models/post.model';
import { useParams } from 'react-router-dom';
import postApi from '../../../api/post.api';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import { Container } from './style';
import CategorySelect from '../../../components/CategorySelect';
import ImageUploadWithPreview from '../../../components/ImageUpload';
import { toast } from 'react-toastify';
import { ContentEditor } from '../../../components';

export default function BlogDetailPage() {
  const [data, setData] = useState<IPostModel>();
  const contentEditorRef = useRef<ContentEditor>(null);

  const [loading, setLoading] = useState(false);

  const params = useParams<{ id: string }>();

  useEffect(() => {
    setLoading(true);
    postApi
      .getDetail(params.id!)
      .then((res) => {
        setData(res.data);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [params.id]);

  useEffect(() => {
    contentEditorRef.current?.updateContentStates({
      content_en: Array.isArray(data?.content_en) ? '' : data?.content_en || '',
      content_vi: Array.isArray(data?.content_vi) ? '' : data?.content_vi || '',
    });
  }, [data?.content_en, data?.content_vi]);

  return (
    <Container>
      <Box
        sx={{
          width: '100%',
          p: 2,
          boxSizing: 'border-box',
        }}
      >
        <Grid container columnSpacing={2} rowSpacing={4}>
          <Grid item xs={12}>
            <Typography variant="h3" p={1}>
              Update blog
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography variant="h5" p={1}>
              Cover Image
            </Typography>

            <ImageUploadWithPreview
              value={data?.picture}
              onChange={(value) => {
                if (data) {
                  setData({
                    ...data,
                    picture: value,
                  });
                }
              }}
            />
          </Grid>

          <Grid item xs={12}>
            <Typography variant="h5" p={1}>
              Order
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <TextField
              label="Order"
              variant="outlined"
              size="small"
              value={data?.order || 0}
              onChange={(ev) => {
                if (data) {
                  setData({
                    ...data,
                    order: +ev.currentTarget.value || 0,
                  });
                }
              }}
              type="number"
              fullWidth
            />
          </Grid>

          <Grid item xs={12}>
            <Typography variant="h5" p={1}>
              Title
            </Typography>
          </Grid>
          <Grid item xs={6}>
            <TextField
              label="Vietnamese"
              variant="outlined"
              size="small"
              value={data?.title_vi || ''}
              onChange={(ev) => {
                if (data) {
                  setData({
                    ...data,
                    title_vi: ev.currentTarget.value,
                  });
                }
              }}
              fullWidth
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              label="English"
              variant="outlined"
              size="small"
              value={data?.title_en || ''}
              onChange={(ev) => {
                if (data) {
                  setData({
                    ...data,
                    title_en: ev.currentTarget.value,
                  });
                }
              }}
              fullWidth
            />
          </Grid>
          <Grid item xs={12}>
            <Typography variant="h5" p={1}>
              Detail
            </Typography>
          </Grid>
          <Grid item xs={6}>
            <CategorySelect
              value={data?.category?.id}
              onChange={(item) => {
                if (data) {
                  setData({
                    ...data,
                    category: item,
                    category_id: item?.id ?? null,
                  });
                }
              }}
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              label="Time to read (min)"
              variant="outlined"
              size="small"
              value={data?.reading_min || 0}
              onChange={(ev) => {
                if (data) {
                  setData({
                    ...data,
                    reading_min: +ev.currentTarget.value || 0,
                  });
                }
              }}
              type="number"
              fullWidth
            />
          </Grid>
          <ContentEditor
            ref={contentEditorRef}
            initData={{
              content_en: Array.isArray(data?.content_en)
                ? ''
                : data?.content_en,
              content_vi: Array.isArray(data?.content_vi)
                ? ''
                : data?.content_vi,
            }}
          />
          <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'center' }}>
            <Button
              disabled={loading || !data}
              sx={{ minWidth: 200 }}
              variant="contained"
              onClick={() => {
                if (data) {
                  const content = contentEditorRef.current?.getContentData();

                  setLoading(true);
                  postApi
                    .update(data?.id, {
                      ...data,
                      ...content,
                    })
                    .then((res) => {
                      toast.success('Update successful');
                      return postApi.getDetail(res.data.id);
                    })
                    .then((res) => {
                      setData(res.data);
                    })
                    .finally(() => {
                      setLoading(false);
                    });
                }
              }}
            >
              Save
            </Button>
          </Grid>
        </Grid>
        <div style={{ height: 100 }} />
      </Box>
    </Container>
  );
}
